<template>
  <CmStatTable
    :isLoading="isLoading"
    :isError="isError"
    :value="value"
    :cols="cols"
    :isLongTable="isLongTable"
    @open-long-table="setLongTablePart(longTableId)"
  />
</template>

<script>
import long_table_mixin from "@/components/statistics/stats/tabs/long_table_mixin";
import CmStatTable from "@/components/library/statistics/elements/CmStatTable";

export default {
  mixins: [long_table_mixin],

  components: {
    CmStatTable
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isError: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      longTableId: "opens-hourly-table",
      cols: {
        hours: {
          label: "Период"
        },
        opened:  {
          label: "Уникальных открыто",
          className: "bold td-width--180",
          format: d => this.fNum.format(d)
        },
        openedPercent: {
          label: "",
          format: d => d + "%"
        }
      }
    }
  }
}
</script>

<style lang="scss">
.td-width--180 {
  widows: 180px;
}
</style>
